import gql from 'graphql-tag'

const CREATE_INTEGRATION = gql`
  mutation CreateIntegration($partnerName: PartnerName!) {
    createIntegration(partnerName: $partnerName)
  }
`
const REMOVE_INTEGRATION = gql`
  mutation RemoveIntegration($partnerName: PartnerName!) {
    removeIntegration(partnerName: $partnerName)
  }
`

const GET_INTEGRATIONS = gql`
  query GetIntegrations {
    getIntegrations {
      type
      status
      category
      stores {
        connected {
          id
          name
        }
        notConnected {
          id
          name
        }
      }
    }
  }
`

export { CREATE_INTEGRATION, REMOVE_INTEGRATION, GET_INTEGRATIONS }
